import { Card } from '@iwoca/orion';

import { LinkWithQuery } from '../../../../components/LinkWithQuery/LinkWithQuery';
import chevronRight from '../../../../components/svg/ChevronRight.svg';

export const SellerDashboardCard = ({
  icons,
  title,
  link,
  children,
  externalLink,
}: {
  icons?: Array<{ icon: string; alt: string }>;
  title?: string;
  link?: { text: string; href: string };
  children?: React.ReactNode;
  externalLink?: boolean;
}) => {
  return (
    <Card className="mb-l gap-s !border-secondary-80 !text-left">
      {icons && (
        <div className="flex flex-row gap-l">
          {icons.map((icon) => (
            <img
              key={icon.alt}
              src={icon.icon}
              alt={icon.alt}
              className="max-h-[2rem] max-w-[2rem]"
            ></img>
          ))}
        </div>
      )}
      {title && <div className="m-0 text-m font-bold">{title}</div>}
      {children && <div className="text-s font-reg">{children}</div>}
      {link &&
        (externalLink ? (
          <a
            className="my-s inline-flex items-center text-s font-bold text-primary-40 no-underline"
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.text}
            <img
              src={chevronRight}
              alt="arrow"
              className="ml-[0.1rem] mt-[0.1rem] h-[1rem]"
            />
          </a>
        ) : (
          <LinkWithQuery
            className="my-s inline-flex items-center text-s font-bold text-primary-40 no-underline"
            to={link.href}
          >
            {link.text}
            <img
              src={chevronRight}
              alt="arrow"
              className="ml-[0.1rem] mt-[0.1rem] h-[1rem]"
            />
          </LinkWithQuery>
        ))}
    </Card>
  );
};
